export default "__VITE_ASSET__NSiG7f18__"